// extracted by mini-css-extract-plugin
module.exports = {"departments":"Lf","departmentHeading":"Mf","departmentSection":"Nf","departmentName":"Of","departmentLink":"Pf","expandIcon":"Qf"};